const ExpirationRanges = [
    { name: 'Expired in the past year', field: 'expiredAlready' },
    { name: 'Expiring between 90 days and the end of year', field: 'endOfThisYear' },
    { name: 'Expiring between 30 and 90 days', field: 'ninetyDays' },
    { name: 'Expiring between 7 and 30 days', field: 'thirtyDays' },
    { name: 'Expiring between 1 and 7 days', field: 'sevenDays' },
    { name: 'Expiring in 1 day', field: 'oneDay' }
]
export { ExpirationRanges }